import { CustomerStatus, STATUS_BADGE_CLASS, STATUS_LABEL } from "../../../../../lib/customersEngageV1";

export const StatusBadge = ({ status }: { status: string | null | undefined }) => {
  const s = (status ?? "new") as CustomerStatus;
  const cls = STATUS_BADGE_CLASS[s] ?? STATUS_BADGE_CLASS.new;
  const label = STATUS_LABEL[s] ?? s;
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full border text-xs font-medium ${cls}`}>
      {label}
    </span>
  );
};
